import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "w-full bg-white border border-[#E5E7EB] rounded-xl shadow-sm text-left overflow-hidden",
  "data-testid": "exceptionality-progress-timeline"
}
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = {
  key: 0,
  class: "w-8 h-8 rounded-full border-4 border-alert bg-[#FEF3E7] flex items-center justify-center shrink-0",
  "data-testid": "progress-timeline-status-icon"
}
const _hoisted_4 = { class: "text-textPrimary text-[11px] font-bold leading-none" }
const _hoisted_5 = {
  key: 1,
  class: "w-8 h-8 rounded-full border border-negative bg-[#FDF3F4] flex items-center justify-center shrink-0",
  "data-testid": "progress-timeline-status-icon"
}
const _hoisted_6 = { class: "w-3.5 h-3.5 rounded-full bg-negative flex items-center justify-center" }
const _hoisted_7 = {
  key: 2,
  class: "w-8 h-8 rounded-full bg-negative flex items-center justify-center shrink-0",
  "data-testid": "progress-timeline-status-icon"
}
const _hoisted_8 = { class: "text-[17px] font-bold text-textPrimary tracking-tight" }
const _hoisted_9 = { class: "relative px-5 pb-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "absolute left-[29px] top-0 bottom-4 w-[2px] bg-[#CBD5E1] z-0" }, null, -1)
const _hoisted_11 = { class: "flex gap-3 relative z-10 mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-5 shrink-0 flex justify-center pt-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-2 h-2 rounded-full bg-negative" })
], -1)
const _hoisted_13 = ["data-testid"]
const _hoisted_14 = ["data-testid"]
const _hoisted_15 = { class: "w-5 shrink-0 flex justify-center pt-px" }
const _hoisted_16 = {
  key: 0,
  class: "w-4 h-4 rounded-full bg-negative flex items-center justify-center"
}
const _hoisted_17 = {
  key: 1,
  class: "w-3 h-3 rounded-full border-2 border-alert bg-white mt-1"
}
const _hoisted_18 = {
  key: 2,
  class: "w-5 h-5 rounded-full bg-negative flex items-center justify-center"
}
const _hoisted_19 = {
  key: 3,
  class: "w-2.5 h-2.5 rounded-full bg-neutral50 mt-1"
}
const _hoisted_20 = { class: "flex flex-col min-w-0" }
const _hoisted_21 = { class: "text-[14px] text-neutral50 leading-snug" }
const _hoisted_22 = {
  key: 0,
  class: "font-bold mr-1.5"
}
const _hoisted_23 = { class: "font-normal" }
const _hoisted_24 = {
  key: 0,
  class: "text-[12px] text-gray-400 mt-0.5 font-normal tracking-wide"
}
const _hoisted_25 = ["data-testid"]
const _hoisted_26 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_27 = {
  class: "flex gap-3 relative z-10",
  "data-testid": "progress-base-event"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "w-5 shrink-0 flex justify-center pt-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-2.5 h-2.5 rounded-full bg-primary20" })
], -1)
const _hoisted_29 = { class: "flex flex-col" }
const _hoisted_30 = { class: "text-[14px] text-neutral50 leading-snug" }
const _hoisted_31 = { class: "font-bold mr-1.5" }
const _hoisted_32 = { class: "font-normal" }
const _hoisted_33 = {
  key: 0,
  class: "text-[12px] text-gray-400 mt-0.5 font-normal tracking-wide"
}

import { ref } from 'vue'
import { mdiCheck, mdiClose, mdiChevronUp, mdiChevronDown } from '@mdi/js'

import type {
  ProgressHeaderStatus,
  ProgressLayer,
  ProgressBaseEvent
} from '../types/progress-timeline.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionalityProgressTimeline',
  props: {
    headerStatus: {},
    title: {},
    layers: {},
    baseEvent: {},
    defaultExpanded: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;



const isExpanded = ref(props.defaultExpanded)

function getBadgeClasses(variant: string): string {
  return variant === 'dark'
    ? 'border-sucess bg-[#EAFBEF] text-textPrimary'
    : 'border-primary bg-[#D8EEF3] text-textPrimary'
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "w-full flex items-center justify-between px-5 py-4",
      "data-testid": "progress-timeline-toggle-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpanded.value = !isExpanded.value))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.headerStatus.type === 'in-progress')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.headerStatus.current) + "/" + _toDisplayString(_ctx.headerStatus.total), 1)
            ]))
          : (_ctx.headerStatus.type === 'approved')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_v_icon, {
                    size: 10,
                    color: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(mdiCheck)), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_v_icon, {
                  size: 18,
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(mdiClose)), 1)
                  ]),
                  _: 1
                })
              ])),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.title), 1)
      ]),
      _createVNode(_component_v_icon, {
        size: 22,
        color: "#6B7280"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(isExpanded.value ? _unref(mdiChevronUp) : _unref(mdiChevronDown)), 1)
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layers, (layer, layerIdx) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: layerIdx }, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", {
              class: "inline-flex items-center px-2 py-0.5 rounded text-[11px] font-normal tracking-wide border border-[#D1D5DB] text-textPrimary bg-white",
              "data-testid": `progress-layer-tag-${layerIdx}`
            }, _toDisplayString(layer.operatorLabel), 9, _hoisted_13)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layer.events, (event, eventIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${layerIdx}-${eventIdx}`,
              class: "flex gap-3 relative z-10 mb-2",
              "data-testid": `progress-event-${layerIdx}-${eventIdx}`
            }, [
              _createElementVNode("div", _hoisted_15, [
                (event.status === 'approved')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_v_icon, {
                        size: 10,
                        color: "white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(mdiCheck)), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : (event.status === 'pending')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                    : (event.status === 'rejected')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_v_icon, {
                            size: 14,
                            color: "white"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(mdiClose)), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("p", _hoisted_21, [
                  (event.date)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(event.date), 1))
                    : _createCommentVNode("", true),
                  (event.badge)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(["inline-flex items-center px-1.5 py-px rounded text-[10px] font-bold mr-1.5 align-middle leading-tight border", getBadgeClasses(event.badge.variant)])
                      }, _toDisplayString(event.badge.text), 3))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(event.description), 1)
                ]),
                (event.time)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(event.time), 1))
                  : _createCommentVNode("", true),
                (event.justification?.length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "mt-1 text-[13px] text-textPrimary leading-snug whitespace-pre-line break-words",
                      "data-testid": `progress-event-justification-${layerIdx}-${eventIdx}`
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.justification, (item, itemIdx) => {
                        return (_openBlock(), _createElementBlock("p", { key: itemIdx }, [
                          (item.title)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item.title) + ":", 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(item.text), 1)
                        ]))
                      }), 128))
                    ], 8, _hoisted_25))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_14))
          }), 128))
        ], 64))
      }), 128)),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("p", _hoisted_30, [
            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.baseEvent.date), 1),
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.baseEvent.description), 1)
          ]),
          (_ctx.baseEvent.time)
            ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.baseEvent.time), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, isExpanded.value]
    ])
  ]))
}
}

})